// Currency display config
let defaultCurrencySymbol = '$'
let isSymbolAfterAmount = false
export const setCurrencySymbol = (symbol?: string) => { defaultCurrencySymbol = symbol || '$' }
export const setSymbolAfterAmount = (after?: boolean) => { isSymbolAfterAmount = after || false }
export const getCurrencySymbol = () => defaultCurrencySymbol

// Format number with thousand/million separators
export function formatNumber(value: number | string | null | undefined, decimals: number = 2): string {
  if (value == null) return '0'
  const num = typeof value === 'string' ? parseFloat(value) : value
  if (isNaN(num)) return '0'
  return num.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
}

// Format currency with symbol and thousand separators (uses formatPrice for smart decimal handling)
export function formatCurrency(value: number | string | null | undefined, symbol?: string, decimals: number = 2): string {
  const num = value == null ? 0 : typeof value === 'string' ? parseFloat(value) : value
  const s = symbol ?? defaultCurrencySymbol
  return isSymbolAfterAmount ? `${formatPrice(num, decimals)}${s}` : `${s}${formatPrice(num, decimals)}`
}

// Format price: hide decimal for integers, show decimals for floats (saves space for large currencies like VND)
export function formatPrice(value: number, decimals: number = 2): string {
  return formatNumber(value, value % 1 === 0 ? 0 : decimals)
}

// Format weight: grams < 1000 show as g, >= 1000 show as kg (input: grams)
export function formatWeight(grams: number | null | undefined): string {
  if (grams == null || isNaN(grams)) return '0g'
  if (Math.abs(grams) >= 1000) return `${parseFloat((grams / 1000).toFixed(3))}kg`
  return `${Math.round(grams)}g`
}
